<template>
  <div am-image-modal-item>
    <div v-for="side in data.data.sides" :key="side" class="_margin-bottom:1/2" am-images>
      <template v-if="filterImg[side] && filterImg[side].length > 0">
        <div v-for="(img, index) in filterImg[side]" :key="img.id" am-img>
          <div v-if="isAlg" class="_display:flex _margin-bottom:1/2">
            <p class="_margin-right:1/2">Alg</p>
            <i-input
              v-model="img.alg"
              @change="setAlg(index, side)"
            />
          </div>
          <div style="width:20.27vw; height:17.36vw" class="img-holder">
            <img
              v-if="img.imageBase64" :src="'data:image/svg+xml;base64, ' + img.imageBase64"
              am-svg-container :title="img.id" @dblclick="fakeUpdateImage(img)"
            />
            <div
              v-else
              v-html="img.image"
              am-svg-container
              class="_overflow:hidden"
            />
          </div>

          <div
            v-if="!img.image && showUploadButton"
            class="_display:flex _justify-content:center _align-items:center"
          >
            <i-button class="_margin-left:1" @click="openUpload(img.id)">
              Upload file
              <input
                v-show="false"
                :ref="`uploadFile-${img.id}`"
                type="file"
                accept=".svg"
                :multiple="false"
                @change="updateImage"
              />
              <svg
                viewBox="0 0 24 24"
                am-icon="color"
                class="_margin-left:1/2"
              >
                <use xlink:href="@/assets/icons.svg#edit" x="0" y="0" width="24" height="24"></use>
              </svg>
            </i-button>
          </div>
          <div
            v-if="img.image"
            am-buttons
            class="_display:flex _align-items:center _margin-top:1/2 _flex-wrap:wrap"
          >
            <a
              :href="downloadImage(img.image)"
              :download="`${data.name}-${side}.${img.mime}`"
              class="_margin-right:1/2 _margin-bottom:1/2"
            >
              <i-button>
                Download
                <svg viewBox="0 0 16 16" am-icon="color" class="_margin-left:1/2">
                  <use xlink:href="@/assets/icons.svg#download" x="0" y="0" width="16" height="16" />
                </svg>
              </i-button>
            </a>
            <i-button
              v-if="($store.getters.isAdmin && isChild) || img.isNew"
              class="_margin-right:1/2 _margin-bottom:1/2"
              @click="img.isNew ? deleteImg(img) : delImg(img)"
            >
              Delete
              <svg
                viewBox="0 0 24 24"
                am-icon="color"
                class="_margin-left:1/2"
              >
                <use xlink:href="@/assets/icons.svg#delete" x="0" y="0" width="24" height="24"></use>
              </svg>
            </i-button>
            <i-button v-if="!img.isNew" @click="openUpload(img.id)" class="_margin-bottom:1/2">
              Edit
              <input
                v-show="false"
                :ref="`uploadFile-${img.id}`"
                type="file"
                accept=".svg"
                :multiple="false"
                @change="updateImage"
              />
              <svg
                viewBox="0 0 24 24"
                am-icon="color"
                class="_margin-left:1/2"
              >
                <use xlink:href="@/assets/icons.svg#edit" x="0" y="0" width="24" height="24"></use>
              </svg>
            </i-button>
          </div>
          <IAlert color="danger" v-if="img.id === editImagIndex && errorType[editImagIndex]">
            <template #icon>
                <IIcon name="ink-danger" />
            </template>
            You can upload only svg files
          </IAlert>
          <image-params v-if="isChild" :image="img" :data="data" />
          <image-attrs
            v-if="allAttrType(side).length > 0"
            :image="img"
            :types="allAttrType(side)"
            :data="data"
          />
        </div>
      </template>
      <IAlert class="_margin-top:1/2" color="danger" v-if="errorType.new">
        <template #icon>
            <IIcon name="ink-danger" />
        </template>
        You can upload only svg files
      </IAlert>
      <i-card
        v-if="isChild || filterImg[side].length === 0"
        am-upload-card
        class="_margin-top:1/2 _width:100%"
      >
        <label am-upload-area>
          <div am-upload-area-text>
            Drag files to this area or  <span>select from your computer</span>
          </div>
          <input
            type="file"
            title="Drag files to this area"
            accept=".svg"
            multiple
            @change="updateFileList"
          />
        </label>
      </i-card>
    </div>
  </div>
</template>

<script>
import ImageParams from '../ImageParams.vue'
import ImageAttrs from '../ImageAttrs.vue'

import { mapMutations } from 'vuex'

export default {
  name: 'ImageItem',
  components: { ImageParams, ImageAttrs },
  props: {
    data: {
      type: Object,
      required: true
    },
    image: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isOpenModal: false,
    // backend doesn't provide part_image records with an empty image
    showUploadButton: false,
    errorType: {},
    editImagIndex: false
  }),
  computed: {
    isChild () {
      if (this.data.data.typeImage === 'children') return true
      return false
    },
    isAlg () {
      if (this.filterImg[this.data.side || this.data.sides[0]].find(el => el.alg)) return true
      return false
    },
    filterImg () {
      const images = {}
      this.data.data.sides.forEach(side => {
        images[side] = this.image.filter(el => {
          if (this.data.alg) return el.type === this.data.type && el.alg === this.data.alg && el.side === side
          else return el.type === this.data.type && el.side === side
        })
      })
      return images
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_IMAGES', 'DEL_CHANGED_IMAGE', 'SET_CHANGED_PARTS']),
    setAlg (index, side) {
      this.SET_CHANGED_IMAGES({
        subtable: this.$route.params.subtable,
        data: this.filterImg[side][index],
        field: 'alg',
        partInfo: this.data
      })
    },
    allAttrType (side) {
      if (this.filterImg) {
        const attrsType = []
        this.filterImg[side].forEach(el => {
          el.attrs.forEach(attr => {
            if (!attrsType.includes(attr.type)) {
              attrsType.push(attr.type)
            }
          })
        })
        if (this.data.all_attrs) {
          this.data.all_attrs.forEach(el => {
            if (!attrsType.includes(el)) {
              attrsType.push(el)
            }
          })
        }
        return attrsType.sort((a, b) => a > b ? 1 : -1)
      } else return false
    },
    downloadImage (img) {
      const blob = new Blob([img], {
        type: 'image/svg'
      })
      return window.URL.createObjectURL(blob)
    },
    openUpload (index) {
      this.editImagIndex = index
      this.$refs['uploadFile-' + index][0].click()
    },
    delImg (img) {
      this.SET_CHANGED_PARTS({
        subtable: this.$route.params.subtable,
        data: {
          value: {
            ...img,
            data: this.data
          },
          rowIndex: this.data.rowIndex,
          type: 'delete_image_ids',
          id: img.id
        }
      })
      this.$emit('delImg', img.id)
    },
    deleteImg (img) {
      this.DEL_CHANGED_IMAGE({
        subtable: this.$route.params.subtable,
        id: img.id
      })
      this.$emit('delImg', img.id)
    },
    updateFileList (event) {
      const files = event.target.files
      Array.prototype.forEach.call(files, file => {
        if (file.type.includes('svg')) {
          this.errorType.new = false
          file.text().then(svgText => {
            let imageForBase64 = svgText
            if (!imageForBase64.includes('xmlns="http://www.w3.org/2000/svg"')) {
              imageForBase64 = imageForBase64.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"')
            }
            let id = `new_${this.data.side || this.data.sides[0]}_${this.data.type}_` +
              `${this.data.data.part_id}_${this.filterImg?.[this.data.side]?.length || 0}`
            if (this.$store.state.parts.changedImages?.[this.$route.params.subtable]?.[id]) {
              const lastKey = Object.keys(this.$store.state.parts.changedImages[this.$route.params.subtable]).reverse()[0]
              const keyArray = lastKey.split('_')
              id = `new_${this.data.side || this.data.sides[0]}_${this.data.type}_` +
                `${this.data.data.part_id}_${Number(keyArray[4]) + 1}`
            }
            this.$emit('addImg', {
              isNew: true,
              image: imageForBase64,
              imageBase64: btoa(unescape(encodeURIComponent(imageForBase64))),
              id: id,
              side: this.data.side || this.data.sides[0],
              mime: 'svg',
              type: this.data.type,
              alg: null,
              params: {},
              attrs: [],
              part_id: this.data.data.part_id
            })
            this.SET_CHANGED_IMAGES({
              subtable: this.$route.params.subtable,
              data: this.image[this.image.length - 1],
              field: 'image',
              partInfo: this.data
            })
          })
        } else this.errorType.new = true
      })
    },
    updateImage (event) {
      if (event.target.files[0].type.includes('svg') && this.editImagIndex !== null) {
        this.errorType[this.editImagIndex] = false
        const img = this.image.find(el => el.id === this.editImagIndex)
        event.target.files[0].text().then(svgText => {
          img.image = svgText
          if (!svgText.includes('xmlns="http://www.w3.org/2000/svg"')) {
            svgText = svgText.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"')
          }
          img.imageBase64 = btoa(unescape(encodeURIComponent(svgText)))
          this.SET_CHANGED_IMAGES({
            subtable: this.$route.params.subtable,
            data: img,
            field: 'image',
            partInfo: this.data,
            isUpdate: true
          })
        })
      } else if (!event.target.files[0].type.includes('svg')) {
        this.errorType[this.editImagIndex] = true
      }
    },
    fakeUpdateImage (img) {
      this.SET_CHANGED_IMAGES({
        subtable: this.$route.params.subtable,
        data: img,
        field: 'image',
        partInfo: this.data,
        isUpdate: true
      })
    }
  }
}
</script>

<style lang="scss">
[am-image-modal-item] {
  [am-buttons] a:hover{
    text-decoration: none;
  }
  [am-images] {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    [am-img] {
      border: 1px solid var(--color--dark-40);
      width: 50%;
      padding: 1rem;
    }
    [am-upload-area] {
      [am-input] {
        opacity: 0;
        position: absolute;
      }
      position: relative;
      width: 100%;

      [am-upload-area-text] {
        text-align: center;
        padding: 3rem;

        span { text-decoration: underline; }
      }

      input {
        position: absolute;
        z-index: 5;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
    [am-upload-card] > .card-body {
      padding: 0 !important;
    }
  }
}
</style>
